import * as React from "react";
import { AuditModalBody } from "../../auditmodal/components/AuditModalBody";
import Alert, { AlertCategoryEnum } from "../../misc/components/Alert";
import { useNavigate } from "react-router-dom";
import { Phases } from "../../misc/api/ApiPhases";
import { StudyScheduleVisit } from "webportalclient";

export interface SkippingVisitProps {
    outstandingVisits: StudyScheduleVisit[];
    selected: string[];
    onStartSession: (annotation: string) => void;
    goBack: () => void;
}

export const SkippingVisit = ({ outstandingVisits, selected, onStartSession, goBack }: SkippingVisitProps) => {

    const newVisit = outstandingVisits.map(v => v.studyScheduleSessions.filter(v => selected.includes(v.id)).length > 0 ? v : null)
        .filter(x => x);

    const onSkip = (annotation: string) => {
        onStartSession(annotation);
    }

    return (
        <AuditModalBody isSubmitting={false} onClose={() => goBack()} onSubmit={(values) => onSkip(values.Annotation)}>
            {newVisit[0].phaseId !== Phases.Unscheduled ?
                <Alert show={true} category={AlertCategoryEnum.Warning}>
                    You have selected a new visit ({newVisit[0].label}) beyond the current visit. Are you sure you wish to skip ahead to {newVisit[0].label}?
                </Alert>
                : <Alert show={true} category={AlertCategoryEnum.Warning}>
                    You have selected an unscheduled visit. Are you sure you wish to continue?
                </Alert>
            }
        </AuditModalBody>
    );
}
